import { fetchCall, HandleStatusCode } from "../common/FetchHelpers";
import { GetReqConfig } from "../common/authHeaders";

const getRRIAsUrl = "api/profile/rria-info";
const getRoleUrl = "api/profile/user-role";

const ProfileService = {
    GetRepInfo: () => {
        const url = getRRIAsUrl;

        return fetchCall(url, GetReqConfig());
    },

    GetUserRole: () => {
        const url = getRoleUrl;

        return fetch(url, GetReqConfig())
            .then((res) => HandleStatusCode(res))
            .then((res) => res.text());
    }
}

export default ProfileService;